import React from 'react';
import { SvgProps } from './icon.types';

function WarningIcon({ fillColor = '#2D3049', title, ...props }: SvgProps) {
  return (
    <svg height={24} viewBox=" 0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M12 2.5l10 19H2l10-19zm0 4.293L5.312 19.5h13.375L12 6.793zm0 9.707a1.001 1.001 0 010 2 1 1 0 110-2zm1-6v5h-2v-5h2z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { WarningIcon };
